<p class="fw-bold fs-4">{{ title() | translate }}</p>

<div class="page-panel bg-card shadow p-2 my-5">
    <div class="title fs-5 fw-bold">
        <span>{{ configuredScheduleLabel() }}</span>
    </div>

    <form class="row mt-4" [formGroup]="scheduleForm">
        @if (this.pageType() === SynchronizationSchedulePageType.DIMENSIONS) {
            <div class="col-12">
                <adaa-form-dropdown
                    [label]="'dimension.choose_type' | translate"
                    [options]="dimensionTypes()"
                    [setDefaultValue]="1"
                    (inputChanges)="getSelectedSchedule($event)"
                />
            </div>
        }

        <div class="col-12 col-md-4">
            <adaa-form-dropdown
                controlName="frequency"
                formControlName="frequency"
                [label]="'khadamati.schedule.configuration' | translate"
                [options]="frequencyOptions()"
                [required]="true"
                [invalid]="checkInvalid('frequency')"
            />
        </div>

        @if (isMonthly()) {
            <div class="col-12 col-md-4">
                <adaa-form-dropdown
                    controlName="dayOfMonth"
                    formControlName="dayOfMonth"
                    [label]="'khadamati.schedule.dayOfMonth' | translate"
                    [options]="months()"
                    [required]="true"
                    [invalid]="checkInvalid('dayOfMonth')"
                />
            </div>
        }

        @if (isWeekly()) {
            <div class="col-12 col-md-4">
                <adaa-form-dropdown
                    controlName="dayOfWeek"
                    formControlName="dayOfWeek"
                    [label]="'khadamati.schedule.week.choose' | translate"
                    [options]="weeks()"
                    [required]="true"
                    [invalid]="checkInvalid('dayOfWeek')"
                />
            </div>
        }

        @if (showTime()) {
            <div class="col-12 col-md-4">
                <adaa-form-input-time
                    controlName="time"
                    formControlName="time"
                    [label]="'time.time' | translate"
                    [required]="true"
                    [invalid]="checkInvalid('time')"
                />
            </div>
        }
    </form>

    <div class="d-flex justify-content-center mt-5">
        <button type="submit" class="btn btn-primary action-buttons" (click)="saveSyncSchedule()">
            <span class="fw-bold">{{ "workflow_rejection_scheduler.buttons.submit_config" | translate }}</span>
        </button>
    </div>
</div>

<div class="page-panel bg-card shadow p-2">
    @if (this.pageType() !== SynchronizationSchedulePageType.WORKFLOW_DECISION) {
        <div class="title fs-5 fw-bold">
            <span>{{ "khadamati.manual_sync.title" | translate }}</span>
        </div>
    }

    <div class="row d-flex flex-column align-items-center justify-content-center my-4">
        @if (this.pageType() === SynchronizationSchedulePageType.WORKFLOW_DECISION) {
            <div class="col-md-4 col-sm-12">
                <adaa-form-input
                    [label]="'workflow_rejection_scheduler.pending_days' | translate"
                    [setDefaultValue]="wfCleanupConfig().intervalDays"
                    (inputChanges)="setInput($event)"
                />
            </div>
        }

        <div class="col-12">
            <div class="d-flex flex-column align-items-center justify-content-center">
                <div class="col-3 text-center">
                    <button
                        type="submit"
                        class="btn btn-secondary action-buttons"
                        [class.btn-danger]="syncButtonDanger()"
                        [disabled]="isSyncDisabled()"
                        (click)="startStopSync()"
                    >
                        <span class="fw-bold">{{ syncButtonLabel() | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    @if (showLastSyncDate()) {
        <p class="text-center fw-bold">
            {{ "khadamati.last_sync_date" | translate }} <span dir="ltr">{{ lastDate() }}</span>
        </p>
    }
</div>
